"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Card_styled_1 = require("./Card.styled");
const Card_types_1 = require("./Card.types");
const Card = ({ orientation = Card_types_1.CardOrientation.Portrait, selected = false, cardStyle = Card_types_1.CardStyle.Plain, cardHero, cardBody, onClick, dataTestId = 'card-element', disabled }) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    return (react_1.default.createElement(Card_styled_1.StyledCardContainer, Object.assign({ orientation: orientation, selected: selected, cardStyle: cardStyle }, (!disabled && { onClick }), { hover: !disabled && !!onClick, theme: theme, "data-testid": dataTestId, disabled: disabled }),
        cardHero && (react_1.default.createElement(Card_styled_1.StyledCardHero, { orientation: orientation, theme: theme, "data-testid": `${dataTestId}-hero`, disabled: disabled }, cardHero)),
        cardBody && (react_1.default.createElement(Card_styled_1.StyledCardBody, { orientation: orientation, theme: theme, "data-testid": `${dataTestId}-body` }, cardBody))));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map